<div class="maxWidthMaxHeight p-3">
    <router-outlet></router-outlet>
</div>
